import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CommentsPostComponent } from "@app/shared/components/comments-post/comments-post.component";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import { VisualizationOptionsType } from "@arch/_shared/types/options-visualization";
import {
    CompanyEntity,
    VisualizationEntity,
    ReportEntity
} from "@arch/domain/entity";

@Component({
    selector: "app-comments-post-dialog",
    imports: [SharedMaterialModule, SharedDsnModule, CommentsPostComponent],
    templateUrl: "./comments-post-dialog.component.html",
    styleUrl: "./comments-post-dialog.component.scss"
})
export class CommentsPostDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<CommentsPostDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: CommentsPostDialotComponentDataInputType
    ) {}
}

type CommentsPostDialotComponentDataInputType = {
    visualization: VisualizationEntity;
    company: CompanyEntity;
    report: ReportEntity;
    options: VisualizationOptionsType;
};
